import React, { PropsWithChildren } from 'react';

const DrawControlsLabel = ({ children }: PropsWithChildren) => {
  return <h2 className="draw-settings__label">{children}</h2>;
};

export default DrawControlsLabel;
